import type { ComponentProps } from "react";

export const WarningAltIconNotif = (props: ComponentProps<"svg">) => {
  return (
    <svg
      width="63"
      height="63"
      viewBox="0 0 63 63"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="31.5" cy="31.5" r="31.5" fill="#FFF0EE" />
      <circle cx="31.4994" cy="31.4994" r="27.8793" fill="#FF7B6F" />
      <path
        d="M31.7171 35.9168C30.4302 35.9168 29.3802 34.8866 29.3557 33.6L29.1244 21.4698C29.0967 20.0185 30.2656 18.8271 31.7171 18.8271V18.8271C33.1686 18.8271 34.3375 20.0185 34.3098 21.4698L34.0785 33.6C34.054 34.8866 33.004 35.9168 31.7171 35.9168V35.9168ZM31.7171 44.7151C30.9206 44.7151 30.2326 44.4375 29.6533 43.8823C29.0981 43.303 28.8206 42.6151 28.8206 41.8185C28.8206 41.022 29.0981 40.3461 29.6533 39.7909C30.2326 39.2116 30.9206 38.922 31.7171 38.922C32.5137 38.922 33.1895 39.2116 33.7447 39.7909C34.324 40.3461 34.6137 41.022 34.6137 41.8185C34.6137 42.6151 34.324 43.303 33.7447 43.8823C33.1895 44.4375 32.5137 44.7151 31.7171 44.7151Z"
        fill="white"
      />
    </svg>
  );
};